export enum AreaClienteActiveMenu {
  PROPOSTAS = 'propostas',
  CONTRATOS = 'contratos',
}
